export class CurrencyGeoData {

    public static euLocales: Array<string> = ['bg', 'de', 'ca', 'ca_ES', 'hr', 'hr_HR', 'cs', 'cs_CZ', 'da', 'da_DK', 'nl_BE', 'nl_NL', 'nl',
        'et', 'et_EE', 'fi', 'fi_FI', 'fr', 'ga_IE', 'ga', 'el_CY', 'el_GR', 'el', 'it_IT', 'it_CH',
        'it', 'lv_LV', 'lv', 'lt_LT', 'lt', 'mt_MT', 'mt', 'pt', 'sk_SK', 'sk', 'sl_SL', 'sl', 'es_ES', 'es'];

    public static checkIfEuLocale(geo: string): string {
        if (geo.includes('de') || geo.includes('fr') || CurrencyGeoData.euLocales.indexOf(geo) !== -1)
            return 'eu';

        return geo;
    }

    public static getGeoBasedCurrency(geo: string): string {
        let result = 'USD';

        geo = CurrencyGeoData.checkIfEuLocale(geo);

        switch (geo) {
            case 'en_GB': result = 'GBP'; break;
            case 'en_US': result = 'USD'; break;
            case 'en_CA': result = 'CAD'; break;
            case 'en_AU': result = 'AUD'; break;
            case 'en': result = 'USD'; break;
            case 'eu': result = 'EUR'; break;
            default: result = 'USD'; break;
        }

        return result;
    }


}